module.exports = __webpack_public_path__ + "static/media/Asset 150.0f4d1476.png";